<div class="modal-backdrop" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="modal-header">
            <div class="header-info">
                <h5>Start Your Application Below</h5>
                <!-- <p>Complete your profile to unlock loan offers</p> -->
            </div>
            <button class="close-btn" (click)="closeModal()">
                <img src="assets/icons/close-48.png" alt="Close" />
            </button>
        </div>

        <!-- Progress Bar -->
        <div class="progress-container">
            <div class="progress-bar" [style.width.%]="(currentStep / totalSteps) * 100"></div>
            <div class="steps-info">Step {{ currentStep }} of {{ totalSteps }}</div>
        </div>

        <!-- Form Content -->
        <form *ngIf="!isSuccess" [formGroup]="registrationForm" class="modal-body">

            <!-- Step 1: Personal Profile -->
            <div *ngIf="currentStep === 1" class="step-content animate-fade-in">
                <div class="form-row">
                    <div class="form-group">
                        <label>First Name</label>
                        <input type="text" formControlName="firstName" placeholder="" autocomplete="given-name">
                    </div>
                    <div class="form-group">
                        <label>Last Name</label>
                        <input type="text" formControlName="lastName" placeholder="" autocomplete="family-name">
                    </div>
                </div>
                <div class="form-group">
                    <label>Email Address</label>
                    <input type="email" formControlName="email" placeholder="" autocomplete="email">
                </div>
                <div class="form-group">
                    <label>Enter your Mobile Number</label>
                    <input type="text" formControlName="mobileNumber" class="disabled-input">
                </div>
            </div>

            <!-- Step 2: Financial Details -->
            <div *ngIf="currentStep === 2" class="step-content animate-fade-in">
                <div class="form-group">
                    <label>Monthly Income (₹)</label>
                    <input type="number" formControlName="monthlyIncome" placeholder="e.g. 50000">
                </div>
                <div class="form-group">
                    <label>Employment Status</label>
                    <select formControlName="employmentStatus">
                        <option [value]="1">Salaried</option>
                        <option [value]="2">Self-employed</option>
                        <option [value]="3">Business</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Employer / Business Name</label>
                    <input type="text" formControlName="employerName" placeholder="Company Name">
                </div>
                <div class="form-group" *ngIf="registrationForm.get('employmentStatus')?.value != 1">
                    <label>Business Registration Type</label>
                    <select formControlName="businessRegistrationType">
                        <option value="Proprietorship">Proprietorship</option>
                        <option value="Partnership">Partnership</option>
                        <option value="Private Limited">Private Limited</option>
                        <option value="Public Limited">Public Limited</option>
                        <option value="Trust">Trust</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
            </div>

            <!-- Step 3: Location & Identity -->
            <div *ngIf="currentStep === 3" class="step-content animate-fade-in">
                <div class="form-row">
                    <div class="form-group">
                        <label>Home Pincode</label>
                        <input type="text" formControlName="pincode" placeholder="110001" maxlength="6">
                    </div>
                    <div class="form-group">
                        <label>Office Pincode</label>
                        <input type="text" formControlName="officePincode" placeholder="110025" maxlength="6">
                    </div>
                </div>
                <div class="form-group">
                    <label>PAN Number</label>
                    <input type="text" formControlName="pan" placeholder="ABCDE1234F" maxlength="10"
                        style="text-transform: uppercase;">
                </div>
                <div class="form-group">
                    <label>Date of Birth</label>
                    <input type="date" formControlName="dob">
                </div>
            </div>

            <!-- Status Messages -->
            <div *ngIf="errorMessage" class="error-msg">
                <i class="bi bi-exclamation-circle"></i> {{ errorMessage }}
            </div>
        </form>

        <!-- Success Screen -->
        <div *ngIf="isSuccess" class="success-screen animate-fade-in">
            <div class="success-icon">
                <img src="assets/icons/img_check-circle.svg" alt="Success" width="48" height="48">
            </div>
            <h3>Registration Successful!</h3>
            <p>Your profile has been created. You can now view personalized loan offers tailored for you.</p>
            <button class="btn-primary w-100 mt-4" (click)="finish()">View Offers</button>
        </div>

        <!-- Footer Actions -->
        <div *ngIf="!isSuccess" class="modal-footer">
            <button class="btn-outline" (click)="prevStep()" [disabled]="currentStep === 1 || isLoading">
                Back
            </button>
            <button class="btn-primary" (click)="nextStep()" [disabled]="isLoading">
                <span *ngIf="!isLoading">
                    {{ currentStep === totalSteps ? 'Submit Registration' : 'Continue' }}
                </span>
                <span *ngIf="isLoading" class="spinner-content">
                    <span class="spinner-border spinner-border-sm"></span>
                    <span class="loading-text">Processing...</span>
                </span>
            </button>
        </div>
    </div>
</div>